"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _belSerializer = require("../../../common/serialize/bel-serializer");
var _info = require("../../../common/config/info");
var _agentConstants = require("../../../common/constants/agent-constants");
class Chunk {
  constructor(events, aggregateInstance) {
    this.addString = (0, _belSerializer.getAddStringContext)(aggregateInstance.agentIdentifier); // pass agentIdentifier here
    this.events = events;
    this.payload = 'bel.7;';
    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      const fields = [(0, _belSerializer.numeric)(event.startTime), (0, _belSerializer.numeric)(event.endTime - event.startTime), (0, _belSerializer.numeric)(0),
      // callbackEnd
      (0, _belSerializer.numeric)(0),
      // no callbackDuration for non-SPA events
      this.addString(event.method), (0, _belSerializer.numeric)(event.status), this.addString(event.domain), this.addString(event.path), (0, _belSerializer.numeric)(event.requestSize), (0, _belSerializer.numeric)(event.responseSize), event.type === 'fetch' ? 1 : '', this.addString(0),
      // nodeId
      (0, _belSerializer.nullable)(event.spanId, this.addString, true) +
      // guid
      (0, _belSerializer.nullable)(event.traceId, this.addString, true) +
      // traceId
      (0, _belSerializer.nullable)(event.spanTimestamp, _belSerializer.numeric, false) // timestamp
      ];
      let insert = '2,';

      // Since configuration objects (like info) are created new each time they are set, we have to grab the current pointer to the attr object here.
      const jsAttributes = (0, _info.getInfo)(aggregateInstance.agentIdentifier).jsAttributes;

      // add custom attributes
      // gql decorators are added as custom attributes to alleviate need for new BEL schema
      const attrParts = (0, _belSerializer.addCustomAttributes)({
        ...(jsAttributes || {}),
        ...(event.gql || {})
      }, this.addString);
      fields.unshift((0, _belSerializer.numeric)(attrParts.length));
      insert += fields.join(',');
      if (attrParts && attrParts.length > 0) {
        insert += ';' + attrParts.join(';');
      }
      if (i + 1 < events.length) insert += ';';
      this.payload += insert;
    }
    this.tooBig = this.payload.length * 2 > _agentConstants.MAX_PAYLOAD_SIZE;
  }
}
exports.default = Chunk;